// extracted by mini-css-extract-plugin
module.exports = {"LFPBatteries":"LFPBatteries_LFPBatteries__cadl3"};